import { ErrorBoundary, type FallbackProps } from "react-error-boundary";
import type { ReactNode } from "react";

// A localized boundary for admin-only sections, distinct from the app-wide
// ErrorBoundary in main.tsx — a bug in, say, rendering the product list
// should degrade to an inline message in that section, not take down the
// whole admin page (or the whole app, since the top-level boundary has no
// "try this one section again" concept, only a full page reload). Always
// shows the real error message (not gated to development) since this only
// ever renders for an authenticated admin — there's no one else to hide a
// stack trace from, and seeing it is what actually gets a bug reported
// with enough detail to fix.
function Fallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className="mt-6 border border-accent/40 bg-accent/5 p-6">
      <p className="text-sm font-semibold text-ink">Не удалось отобразить этот раздел.</p>
      <pre className="mt-2 max-w-full overflow-x-auto text-xs text-steel-600">
        {error instanceof Error ? error.message : String(error)}
      </pre>
      <button type="button" onClick={resetErrorBoundary} className="btn-dark-outline mt-4">
        Попробовать снова
      </button>
    </div>
  );
}

export default function AdminSectionErrorBoundary({ children }: { children: ReactNode }) {
  return <ErrorBoundary FallbackComponent={Fallback}>{children}</ErrorBoundary>;
}
